import { Flex } from '@npco/zeller-design-system'

export const TotalIncomeAndExpense = () => {
  return (
    <Flex
      flexDirection="column"
      gap="16px"
      aria-label="Account balance over time"
    >
      <Flex gap="80px">
        <div>IncomeDatapoint</div>
        <div>ExpenseDatapoint</div>
      </Flex>
      <div>TotalIncomeAndExpense</div>
    </Flex>
  )
}
